export default __webpack_public_path__ + "static/media/request-sent.1574039a.svg";